__turbopack_context__.v({
  "cell": "FormattedMarketplaceLogo-module-scss-module__6V9lfq__cell",
  "internal": "FormattedMarketplaceLogo-module-scss-module__6V9lfq__internal",
  "notLoggedIn": "FormattedMarketplaceLogo-module-scss-module__6V9lfq__notLoggedIn",
});
